export const DashboardType = [
  { type: null, name: "없음" },
  { type: 1, name: "최애멤버", filter: ["artistId"] },
  { type: 2, name: "차애멤버", filter: ["artistId"] },
  { type: 3, name: "센터멤버", filter: ["artistId"] },
  { type: 4, name: "입덕멤버", filter: ["artistId"] },
  { type: 5, name: "입덕이유", filter: ["artistId"] },
  { type: 6, name: "입덕시기", filter: ["artistId"] },
  { type: 7, name: "입덕채널", filter: ["artistId"] },
  { type: 8, name: "입덕콘텐츠", filter: ["artistId"] },
  { type: 9, name: "덕질콘텐츠", filter: ["artistId"] },
  { type: 10, name: "화제멤버", filter: ["albumId"] },
  { type: 11, name: "활동컨셉키워드", filter: ["albumId"] },
  { type: 12, name: "활동선호도", filter: ["albumId"] },
  { type: 13, name: "덕질주기", filter: ["artistId"] },
  { type: 14, name: "덕질시간", filter: ["artistId"] },
  { type: 15, name: "덕질채널", filter: ["artistId"] },
  { type: 16, name: "피드백객관식", filter: ["albumId"] },
  { type: 17, name: "피드백주관식", filter: ["albumId"] },
];
